import { createFileRoute } from '@tanstack/react-router';
import { LessonsPage } from '@/features/lessons/LessonsPage';

export const Route = createFileRoute('/lessons/')({
  component: LessonsPage,
});
